import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {parseProbe} from "../parsers";
import DeviceDefaultContent from "./DeviceDefaultContent";
import {createKeysAndLabels} from "./utils";

const ProbeContent = (props) => {
    const {t} = useTranslation();

    const {keys, labels} = useMemo(() => {
        return createKeysAndLabels(
            {
                key: "textTempMean",
                label: t("averageTemperature"),
            },
            {
                key: "textTempMin",
                label: t("minimumTemperature"),
            },
            {
                key: "textTempMax",
                label: t("maximumTemperature"),
            }
        );
    }, [t]);

    return (
        <DeviceDefaultContent
            {...props}
            parseDataFn={parseProbe}
            name={t("farms.tabs.mapTab.types.PROBE")}
            paramKeys={keys}
            paramLabel={labels}
        />
    );
};

export default React.memo(ProbeContent);
